import getClientId from '../storage/getClientId';
import getFieldValue from '../form_wizard/elements/getFieldValue';
import getForm from '../form_wizard/elements/getForm';
import getStepId from '../form_wizard/elements/getStepId';
import getVisitorId from '../storage/getVisitorId';
import getPanelCount from '../storage/getPanelCount';
import { trackFormWizardEvent } from './track_form_wizard_event';

export const selector = [
  '.lead-constructor__panel--welcome.complete .js-lead-constructor__next',
  '.form-wizard--hero .leadform-panel.complete:first-child [data-trigger=next]',
].join();

export default function (element) {
  // Do not push to the data layer if the user goes back to the
  // lead form start page by clicking on back from the panels.
  if (element.querySelector(selector)) return;

  const TRACKING_EVENT = 'lead_form_panel_load';
  const form = getForm(element);
  const formVersion = getFieldValue(form, 'leadform');
  const stepId = getStepId(element);

  trackFormWizardEvent(element, {
    category: 'form_wizard_panel',
    action: `formWizard.${stepId}.load`,
  });

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: TRACKING_EVENT,
    panel_type: element.dataset && element.dataset.component,
    panel_name: stepId,
    panel_count: getPanelCount(TRACKING_EVENT),
    leadform_id: formVersion,
    visitor_id: getVisitorId(),
    client_id: getClientId(),
  });
}
